import React, { useEffect, useMemo, useState, useRef } from "react";
import { useMarketIndicators } from "../../context/MarketIndicatorContext";
import { useSecurityMaster } from "../../context/SecurityMasterContext";
import { useNavigate } from "react-router-dom";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { FiRefreshCw } from "react-icons/fi";
import { usePrediction } from "../../context/PredictionContext";
// import { useExport } from "../../context/ExportContext";
import { useExport } from "../../hooks/useExport";
import { useAuth } from "../../context/AuthNewContext";
import { nseIndicesOptions } from "../Helper/Helperdata";
import { useMarketSnapshot } from "../../context/MarketSnapshotContext";
import "./DailyTrend.css";
import { IoMdTrendingDown, IoMdTrendingUp } from "react-icons/io";
import useLivePrices from "../../hooks/useLivePrices";
import IndexTabs from "../IndexTabs/IndexTabs";
import { useIndexSymbols } from "../../context/IndexSymbolContext";

const DailyTrend = () => {
  const { getLatestNseData, latestNseData } = useMarketIndicators();
  const { exportCSV, exportExcel, exporting } = useExport();
  const [changeFilter, setChangeFilter] = useState("all");
  const [volumeFilter, setVolumeFilter] = useState("all");
  const [recommendationSort, setRecommendationSort] = useState("none");
  const [openDropdown, setOpenDropdown] = useState(false);
  const {
    loadDashboardIndexMarket,
    dashboardMarketData,
    resetDashboardMarketData,
    dashboardLoading,
    dashboardError,
    dashboardIndexData, // ← add this
    dashboardIndexTab, // ← add this too
  } = useMarketSnapshot();
  const { indexSymbols } = useIndexSymbols();
  const {
    prices: livePrices,
    isLive,
    subscribeSymbols,
    lastTickTime,
  } = useLivePrices();

  // New filter
  const [companySort, setCompanySort] = useState("none");
  const [percentSort, setPercentSort] = useState("none");
  const [signalSort, setSignalSort] = useState("none");

  /* 🔥 NEW FILTER FOR ALPHABETICAL ORDER */
  const [alphaFilter, setAlphaFilter] = useState("all");
  const [sending, setSending] = useState(false);

  // new filter for rebound,closing,
  const [closingStrengthSort, setClosingStrengthSort] = useState("none");
  const [reboundStrengthSort, setReboundStrengthSort] = useState("none");
  const [distanceHighSort, setDistanceHighSort] = useState("none");
  const { getSecurityIds } = useSecurityMaster();
  const [filter, setFilter] = useState("All");
  const [lastUpdate, setLastUpdate] = useState("");
  // const [selectedIndex, setSelectedIndex] = useState("NIFTY 50");
  const [selectedIndex, setSelectedIndex] = useState(() => {
    return localStorage.getItem("selectedIndex") || "NIFTY 50";
  });

  const {
    predictionMap,
    fetchPredictions,
    fetchIntradayPredictions,
    intradayPredictionMap,
    intradayLastUpdated,
    loading,
    error,
    lastUpdated,
  } = usePrediction();
  const [latestDataIndex, setLatestDataIndex] = useState("");
  const { user } = useAuth();
  const { downloadIntradayCSV, downloadIntradayExcel, sendReport } =
    useExport();

  const [securityData, setSecurityData] = useState("");
  const navigate = useNavigate();

  // const nseIndicesOptions = [
  //   "NIFTY 50",
  //   "NIFTY BANK",
  //   "NIFTY IT",
  //   "NIFTY NEXT 50",
  //   "NIFTY MIDCAP 100",
  // ];

  console.log("Nifty 50 data", latestNseData);
  const indexSymbolData = latestNseData?.data;
  console.log("Index symbol data", indexSymbolData);
  const initialIndex = selectedIndex;
  // const dataToRender1 = indexSymbolData?.filter((item) => item?.priority !== 1);
  // console.log("Data to render 1", dataToRender1);
  // const symbols = useMemo(() => {
  //   if (!indexSymbolData) return [];
  //   return indexSymbolData
  //     .filter((item) => item?.priority !== 1)
  //     .map((item) => item.symbol);
  // }, [indexSymbolData]);
  const formatVolume = (volume) => {
    if (volume == null) return "-"; // catches null & undefined

    const num = Number(volume);
    if (!Number.isFinite(num)) return "-";

    return num.toLocaleString("en-IN");
  };
  // console.log("Symbols", symbols);
  const trendDate = lastUpdated
    ? new Date(
        new Date(lastUpdated).toLocaleString("en-US", {
          timeZone: "Asia/Kolkata",
        }),
      ).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";
  // const normalizedIndexData =
  //   dataToRender1?.map((item) => ({
  //     ticker_id: item.symbol,
  //     company: item.symbol,
  //     ticker: item.symbol,
  //     price: item.lastPrice,
  //     open: item.open,
  //     close: item.previousClose,
  //     low: item.dayLow,
  //     high: item.dayHigh,
  //     volume: item.totalTradedVolume,
  //     yearHigh: item.yearHigh,
  //     percent_change: item.pChange ?? 0,
  //   })) || [];

  // const formatTimestamp = () => {
  //   const now = new Date();

  //   const day = String(now.getDate()).padStart(2, "0");

  //   const monthNames = [
  //     "Jan",
  //     "Feb",
  //     "Mar",
  //     "Apr",
  //     "May",
  //     "Jun",
  //     "Jul",
  //     "Aug",
  //     "Sep",
  //     "Oct",
  //     "Nov",
  //     "Dec",
  //   ];
  //   const month = monthNames[now.getMonth()];

  //   const year = now.getFullYear();

  //   const time = now.toLocaleTimeString("en-IN", {
  //     hour: "2-digit",
  //     minute: "2-digit",
  //     second: "2-digit",
  //     hour12: false,
  //   });

  //   return `${day}-${month}-${year} ${time} IST`;
  // };

  const handleChangeSort = (value) => {
    setChangeFilter(value);
    setVolumeFilter("all");
  };

  const handleVolumeSort = (value) => {
    setVolumeFilter(value);
    setChangeFilter("all");
  };
  /* 🔥 HANDLE ALPHABETICAL SORT */
  const handleAlphaSort = (value) => {
    setAlphaFilter(value);
    setChangeFilter("all");
    setVolumeFilter("all");
  };

  const calculatePivots = (open, high, low, close) => {
    const range = high - low;

    // Classic
    const classicP = (high + low + close) / 3;
    const classic = {
      R3: high + 2 * (classicP - low),
      R2: classicP + range,
      R1: 2 * classicP - low,
      P: classicP,

      S1: 2 * classicP - high,
      S2: classicP - range,
      S3: low - 2 * (high - classicP),
    };

    // Fibonacci
    const fib = {
      R1: classicP + range * 0.382,
      R2: classicP + range * 0.618,
      R3: classicP + range * 1.0,
      P: classicP,
      S1: classicP - range * 0.382,
      S2: classicP - range * 0.618,
      S3: classicP - range * 1.0,
    };

    // Camarilla
    const cam = {
      R1: close + range * 1.0833,
      R2: close + range * 1.1666,
      R3: close + range * 1.25,
      P: close,
      S1: close - range * 1.0833,
      S2: close - range * 1.1666,
      S3: close - range * 1.25,
    };

    // Woodie
    const woodieP = (high + low + 2 * close) / 4;
    const woodie = {
      R1: 2 * woodieP - low,
      R2: woodieP + range,
      R3: high + 2 * (woodieP - low),
      P: woodieP,
      S1: 2 * woodieP - high,
      S2: woodieP - range,
      S3: low - 2 * (high - woodieP),
    };

    // Demark
    let demPivot;
    if (close < open) {
      demPivot = (high + 2 * low + close) / 4;
    } else if (close > open) {
      demPivot = (2 * high + low + close) / 4;
    } else {
      demPivot = (high + low + 2 * close) / 4;
    }
    const demark = {
      P: demPivot,
      R1: demPivot + range,
      S1: demPivot - range,
    };
    console.log("classic", classic);

    return { classic, fib, cam, woodie, demark };
  };

  const getClassicR1S1 = (symbol) => {
    // const histData = predictionMap?.[symbol]?.hist_data;
    const histData = predictionMap?.[symbol]?.hist_data;
    console.log("histData", histData);
    if (!histData) return null;

    const { open, high, low, close } = histData;

    if (!open?.length || !high?.length || !low?.length || !close?.length) {
      return null;
    }

    // Use latest (daily)
    const o = open?.at(-1);
    const h = high?.at(-1);
    const l = low?.at(-1);
    const c = close?.at(-1);
    console.log("o,h,l,c", o, h, l, c);

    if ([o, h, l, c].some((v) => typeof v !== "number")) return null;

    const pivots = calculatePivots(o, h, l, c);
    console.log("pivots", pivots);

    return {
      R1: pivots.classic.R1,
      S1: pivots.classic.S1,
    };
  };
  const getBgColor = (text) => {
    if (text === "BUY" || text === "Bullish") {
      return "#249966";
    } else if (text === "SELL" || text === "Bearish") {
      return "#f87171";
    } else {
      return "#fbbf24";
    }
  };
  // const handleIndexSelect = (e) => {
  //   const value = e.target.value;
  //   console.log("value seleect", value);
  //   setSelectedIndex(value);

  //   if (!value) return;

  //   // getNseIndexData(value);
  //   getLatestNseData(value);
  // };

  const handleIndexSelect = (e) => {
    const value = e.target.value;
    if (!value) return;

    resetDashboardMarketData();
    setLatestDataIndex("");
    setSelectedIndex(value);
  };

  useEffect(() => {
    if (!selectedIndex) return;

    const fetchIndexData = async () => {
      localStorage.setItem("selectedIndex", selectedIndex);

      await getLatestNseData(selectedIndex);

      setLatestDataIndex(selectedIndex);
    };

    fetchIndexData();
  }, [selectedIndex]);

  const date = new Date();
  // console.log("Date", date);
  // console.log("Last Updted", lastUpdated);
  const checkPercent = (value) => {
    if (value >= 75) {
      return "#249966";
    } else if (value >= 30 && value < 75) {
      return "#fbbf24";
    } else {
      return "#f87171";
    }
  };

  const checkValues = (value) => {
    if (value > 60 && value < 100) {
      return "#249966";
    } else if (value > 31 && value < 59) {
      return "#fbbf24";
    } else {
      return "#f87171";
    }
  };

  // const InfoTooltip = ({ text }) => {
  //   const textItem = text?.text;
  //   return (
  //     <span className="table-tooltip-wrapper">
  //       {textItem?.map((item) => (
  //         <>

  //           ⓘ
  //           <span className="table-tooltip-content" key={item?.id}>
  //             {item?.text}
  //           </span>
  //         </>
  //       ))}
  //     </span>
  //   );
  // };
  const InfoTooltip = ({ text }) => {
    if (!Array.isArray(text)) return null;

    return (
      <span className="table-tooltip-wrapper">
        <span style={{ color: "#fff" }}> ⓘ</span>
        <div className="table-tooltip-content">
          {text.map((item) => (
            <div key={item.id} className="tooltip-line">
              {item.text}
            </div>
          ))}
        </div>
      </span>
    );
  };
  const closeStrength = [
    {
      id: 1,
      text: "🟢 Above 75% → Strong buying at close, buyers dominated, bullish for next day",
    },
    { id: 2, text: "🟡 30% – 75% → Balanced close, neutral momentum" },
    {
      id: 3,
      text: "🔴 Below 30% → Strong selling at close, sellers dominated, bearish signal",
    },
  ];
  const reboundStrength = [
    {
      id: 1,
      text: "🟢 60% – 100% → Strong close near highs, bullish for next day",
    },
    { id: 2, text: "🟡 31% – 59% → Balanced close, neutral momentum" },
    { id: 3, text: "🔴 0% – 30% → Close near lows, strong selling pressure" },
  ];
  const distanceToHigh = [
    { id: 1, text: "🟢 0% – 20% → Close near highs, strong bullish momentum" },
    { id: 2, text: "🟡 21% – 60% → Mid-range close, neutral momentum" },
    { id: 3, text: "🔴 61% – 100% → Close near lows, strong selling pressure" },
  ];

  const distanceToHighValues = (value) => {
    if (value >= 0 && value <= 20) {
      return "#249966"; // 🟢 Close near highs, bullish
    } else if (value >= 21 && value <= 60) {
      return "#fbbf24"; // 🟡 Mid-range close, neutral
    } else {
      return "#f87171"; // 🔴 Close near lows, bearish
    }
  };
  const normalizeSignal = (signal) => {
    if (!signal) return "Neutral";

    if (signal === "BUY" || signal === "Buy" || signal === "Bullish") {
      return "Bullish";
    }

    if (signal === "SELL" || signal === "Sell" || signal === "Bearish") {
      return "Bearish";
    }

    return "Neutral";
  };

  const getSignalRank = (signal) => {
    const normalized = normalizeSignal(signal);

    const rank = {
      Bullish: 1,
      Neutral: 2,
      Bearish: 3,
    };

    return rank[normalized] || 99;
  };

  // const handleRefresh = async () => {
  //   try {
  //     // refresh NSE data
  //     await getLatestNseData(selectedIndex);

  //     // refresh predictions
  //     if (securityData?.length) {
  //       const payload = securityData.map((item) => ({
  //         symbol: item.symbol,
  //         securityId: item.security_id,
  //       }));

  //       await fetchPredictions(payload);
  //     }

  //     // update timestamp
  //     setLastUpdate(formatTimestamp());

  //     console.log("🔄 Data refreshed");
  //   } catch (err) {
  //     console.error("Refresh failed", err);
  //   }
  // };

  //final data to render
  const handleRefresh = async () => {
    try {
      await loadDashboardIndexMarket({
        indexName: selectedIndex,
        // stocks: latestNseData?.data || [],
      });
    } catch (err) {
      console.error("Refresh failed", err);
    }
  };

  /* 🔥 APPLY SORTING WITHOUT TOUCHING EXISTING DATA */
  console.log("IntradayPrediction", intradayPredictionMap);
  // const sortedData = [...normalizedIndexData].sort((a, b) => {

  //   if (changeFilter === "high") return b.percent_change - a.percent_change;
  //   if (changeFilter === "low") return a.percent_change - b.percent_change;

  //   if (volumeFilter === "high") return b.volume - a.volume;
  //   if (volumeFilter === "low") return a.volume - b.volume;

  //   if (alphaFilter === "az") return a.company.localeCompare(b.company);
  //   if (alphaFilter === "za") return b.company.localeCompare(a.company);

  //   return 0;
  // });
  // const sortedData = [...normalizedIndexData].sort((a, b) => {
  //   const recA = intradayPredictionMap[a.company]?.prediction;
  //   const recB = intradayPredictionMap[b.company]?.prediction;

  //   const order = {
  //     Buy: 1,
  //     Neutral: 2,
  //     Sell: 3,
  //   };

  //   if (recommendationSort === "asc") {
  //     return (order[recA] || 99) - (order[recB] || 99);
  //   }

  //   if (recommendationSort === "desc") {
  //     return (order[recB] || 99) - (order[recA] || 99);
  //   }

  //   if (changeFilter === "high") return b.percent_change - a.percent_change;
  //   if (changeFilter === "low") return a.percent_change - b.percent_change;

  //   if (volumeFilter === "high") return b.volume - a.volume;
  //   if (volumeFilter === "low") return a.volume - b.volume;

  //   if (alphaFilter === "az") return a.company.localeCompare(b.company);
  //   if (alphaFilter === "za") return b.company.localeCompare(a.company);

  //   return 0;
  // });

  //commen
  // const sortedData = [...normalizedIndexData].sort((a, b) => {
  //   const recA = intradayPredictionMap[a.company]?.prediction;
  //   const recB = intradayPredictionMap[b.company]?.prediction;

  //   const order = { Buy: 1, Neutral: 2, Sell: 3 };

  //   // 🔹 Recommendation
  //   if (recommendationSort === "asc") {
  //     return (order[recA] || 99) - (order[recB] || 99);
  //   }
  //   if (recommendationSort === "desc") {
  //     return (order[recB] || 99) - (order[recA] || 99);
  //   }

  //   // 🔹 Calculations (SAFE)
  //   const rangeA = a.high - a.low || 1;
  //   const rangeB = b.high - b.low || 1;

  //   const closingA = ((a.price - a.low) / rangeA) * 100;
  //   const closingB = ((b.price - b.low) / rangeB) * 100;

  //   const reboundA = ((Math.min(a.price, a.open) - a.low) / rangeA) * 100;
  //   const reboundB = ((Math.min(b.price, b.open) - b.low) / rangeB) * 100;

  //   const distA = ((a.high - a.price) / rangeA) * 100;
  //   const distB = ((b.high - b.price) / rangeB) * 100;

  //   // 🔥 Closing Strength
  //   if (closingStrengthSort === "high") return closingB - closingA;
  //   if (closingStrengthSort === "low") return closingA - closingB;

  //   // 🔥 Rebound Strength
  //   if (reboundStrengthSort === "high") return reboundB - reboundA;
  //   if (reboundStrengthSort === "low") return reboundA - reboundB;

  //   // 🔥 Distance to High
  //   if (distanceHighSort === "high") return distB - distA;
  //   if (distanceHighSort === "low") return distA - distB;

  //   // Existing sorts
  //   if (changeFilter === "high") return b.percent_change - a.percent_change;
  //   if (changeFilter === "low") return a.percent_change - b.percent_change;

  //   if (volumeFilter === "high") return b.volume - a.volume;
  //   if (volumeFilter === "low") return a.volume - b.volume;

  //   if (alphaFilter === "az") return a.company.localeCompare(b.company);
  //   if (alphaFilter === "za") return b.company.localeCompare(a.company);

  //   return 0;
  // });
  // const sortCompanyAsc = () => {
  //   setAlphaFilter("az");
  //   setChangeFilter("all");
  //   setVolumeFilter("all");
  // };

  // const sortCompanyDesc = () => {
  //   setAlphaFilter("za");
  //   setChangeFilter("all");
  //   setVolumeFilter("all");
  // };

  // const sortPercentHigh = () => {
  //   setChangeFilter("high");
  //   setAlphaFilter("all");
  // };

  // const sortPercentLow = () => {
  //   setChangeFilter("low");
  //   setAlphaFilter("all");
  // };
  // const sortRecommendationAsc = () => {
  //   setRecommendationSort("asc");
  //   setChangeFilter("all");
  //   setAlphaFilter("all");
  //   setVolumeFilter("all");
  // };

  // const sortRecommendationDesc = () => {
  //   setRecommendationSort("desc");
  //   setChangeFilter("all");
  //   setAlphaFilter("all");
  // };
  const sortCompanyAsc = () => {
    setCompanySort("asc");
    setPercentSort("none");
    setSignalSort("none");
  };

  const sortCompanyDesc = () => {
    setCompanySort("desc");
    setPercentSort("none");
    setSignalSort("none");
  };

  const sortPercentHigh = () => {
    setPercentSort("high");
    setCompanySort("none");
    setSignalSort("none");
  };

  const sortPercentLow = () => {
    setPercentSort("low");
    setCompanySort("none");
    setSignalSort("none");
  };

  const sortRecommendationAsc = () => {
    setSignalSort("bullish");
    setCompanySort("none");
    setPercentSort("none");
  };

  const sortRecommendationDesc = () => {
    setSignalSort("bearish");
    setCompanySort("none");
    setPercentSort("none");
  };
  const sortPredictionBullish = () => {
    setSignalSort("predictionBullish");
    setCompanySort("none");
    setPercentSort("none");
  };

  const sortPredictionBearish = () => {
    setSignalSort("predictionBearish");
    setCompanySort("none");
    setPercentSort("none");
  };
  const sortVwapBullish = () => setSignalSort("vwapBullish");
  const sortVwapBearish = () => setSignalSort("vwapBearish");

  const sortUtBullish = () => setSignalSort("utBullish");
  const sortUtBearish = () => setSignalSort("utBearish");

  const sortBbBullish = () => setSignalSort("bbBullish");
  const sortBbBearish = () => setSignalSort("bbBearish");

  const sortSmartBullish = () => setSignalSort("smartBullish");
  const sortSmartBearish = () => setSignalSort("smartBearish");

  //new table data
  const tableData = [...Object.values(dashboardMarketData || {})].sort(
    (a, b) => {
      const symbolA = a?.symbol || "";
      const symbolB = b?.symbol || "";

      const quoteA = a?.quote?.data;
      const quoteB = b?.quote?.data;

      const intradayA = a?.intraday || {};
      const intradayB = b?.intraday || {};

      const smartA = a?.smart_money || {};
      const smartB = b?.smart_money || {};

      // % Change
      const ltpA = quoteA?.last_price || 0;
      const ltpB = quoteB?.last_price || 0;

      const prevCloseA = quoteA?.ohlc?.close || 0;
      const prevCloseB = quoteB?.ohlc?.close || 0;

      const percentA =
        prevCloseA > 0 ? ((ltpA - prevCloseA) / prevCloseA) * 100 : 0;

      const percentB =
        prevCloseB > 0 ? ((ltpB - prevCloseB) / prevCloseB) * 100 : 0;

      // ==========================
      // Company Sort
      // ==========================
      if (companySort === "asc") {
        return symbolA.localeCompare(symbolB);
      }

      if (companySort === "desc") {
        return symbolB.localeCompare(symbolA);
      }

      // ==========================
      // RSI & MACD Trend
      // ==========================
      if (signalSort === "predictionBullish") {
        return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
      }

      if (signalSort === "predictionBearish") {
        return getSignalRank(b?.prediction) - getSignalRank(a?.prediction);
      }

      if (signalSort === "predictionBullish") {
        return getSignalRank(a?.prediction) - getSignalRank(b?.prediction);
      }

      if (signalSort === "predictionBearish") {
        return getSignalRank(b?.prediction) - getSignalRank(a?.prediction);
      }

      // ==========================
      // VWAP Trend
      // ==========================
      if (signalSort === "vwapBullish") {
        return getSignalRank(a?.vwap_signal) - getSignalRank(b?.vwap_signal);
      }

      if (signalSort === "vwapBearish") {
        return getSignalRank(b?.vwap_signal) - getSignalRank(a?.vwap_signal);
      }

      // ==========================
      // UT Signal
      // ==========================
      if (signalSort === "utBullish") {
        return getSignalRank(a?.ut_signal) - getSignalRank(b?.ut_signal);
      }

      if (signalSort === "utBearish") {
        return getSignalRank(b?.ut_signal) - getSignalRank(a?.ut_signal);
      }

      // ==========================
      // BB Signal
      // ==========================
      if (signalSort === "bbBullish") {
        return getSignalRank(a?.bbawe_signal) - getSignalRank(b?.bbawe_signal);
      }

      if (signalSort === "bbBearish") {
        return getSignalRank(b?.bbawe_signal) - getSignalRank(a?.bbawe_signal);
      }
      if (signalSort === "smartBullish") {
        return getSignalRank(a?.smart_signal) - getSignalRank(b?.smart_signal);
      }
      if (signalSort === "smartBearish") {
        return getSignalRank(b?.smart_signal) - getSignalRank(a?.smart_signal);
      }

      // ==========================
      // % Change
      // ==========================
      if (percentSort === "high") {
        return percentB - percentA;
      }

      if (percentSort === "low") {
        return percentA - percentB;
      }

      return 0;
    },
  );
  const formattedTimestamp = intradayLastUpdated
    ? new Date(intradayLastUpdated).toLocaleString("en-IN", {
        timeZone: "Asia/Kolkata",
      })
    : "";
  const datePart = intradayLastUpdated
    ? new Date(intradayLastUpdated).toLocaleDateString("en-IN", {
        timeZone: "Asia/Kolkata",
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  const timePart = intradayLastUpdated
    ? new Date(intradayLastUpdated).toLocaleTimeString("en-IN", {
        timeZone: "Asia/Kolkata",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
    : "";
  // useEffect(() => {
  //   if (latestNseData) {
  //     setLastUpdate(formatTimestamp());
  //   }
  // }, [latestNseData]);

  //sorting function for close,rebound and distance
  const resetAllSorts = () => {
    setClosingStrengthSort("none");
    setReboundStrengthSort("none");
    setDistanceHighSort("none");
    setChangeFilter("all");
    setVolumeFilter("all");
    setAlphaFilter("all");
    setRecommendationSort("none");
  };

  // 🔹 Closing Strength
  const sortClosingHigh = () => {
    resetAllSorts();
    setClosingStrengthSort("high");
  };

  const sortClosingLow = () => {
    resetAllSorts();
    setClosingStrengthSort("low");
  };

  // 🔹 Rebound Strength
  const sortReboundHigh = () => {
    resetAllSorts();
    setReboundStrengthSort("high");
  };

  const sortReboundLow = () => {
    resetAllSorts();
    setReboundStrengthSort("low");
  };

  // 🔹 Distance to High
  const sortDistanceHigh = () => {
    resetAllSorts();
    setDistanceHighSort("high");
  };

  const sortDistanceLow = () => {
    resetAllSorts();
    setDistanceHighSort("low");
  };
  const handleSendReport = async () => {
    try {
      setSending(true);

      await sendReport({
        type: "intraday",
        email: user?.userID, // 🔥 from auth
      });

      window.alert("📧 Report sent to your email!");
    } catch (err) {
      window.alert("❌ Failed to send report");
    } finally {
      setSending(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = () => {
      setOpenDropdown(false);
    };

    if (openDropdown) {
      window.addEventListener("click", handleClickOutside);
    }

    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, [openDropdown]);

  // useEffect(() => {
  //   if (!selectedIndex) return;
  //   if (!latestNseData?.data?.length) return;

  //   loadDashboardIndexMarket({
  //     indexName: selectedIndex,
  //     stocks: latestNseData.data,
  //   });
  // }, [selectedIndex, latestNseData?.data]);

  //previous working code
  // useEffect(() => {
  //   if (!selectedIndex) return;
  //   if (!latestDataIndex) return;
  //   if (selectedIndex !== latestDataIndex) return;
  //   if (!latestNseData?.data?.length) return;

  //   const fetchLatestMarketSnapshot = async () => {
  //     await loadDashboardIndexMarket({
  //       indexName: selectedIndex,
  //       // stocks: latestNseData.data,
  //     });
  //   };

  //   fetchLatestMarketSnapshot();

  //   const interval = setInterval(fetchLatestMarketSnapshot, 60000);

  //   return () => clearInterval(interval);
  // }, [selectedIndex, latestDataIndex, latestNseData?.data]);

  //new code
  // useEffect(() => {
  //   if (!selectedIndex) return;
  //   if (!latestDataIndex) return;
  //   if (selectedIndex !== latestDataIndex) return;

  //   const fetchLatestMarketSnapshot = async () => {
  //     await loadDashboardIndexMarket({
  //       indexName: selectedIndex,
  //     });
  //   };

  //   fetchLatestMarketSnapshot();
  // }, [selectedIndex, latestDataIndex]);
  useEffect(() => {
    if (!selectedIndex) return;
    if (!latestDataIndex) return;
    if (selectedIndex !== latestDataIndex) return;

    // Subscribe index name + equity symbols for live prices
    const equitySymbols = indexSymbols?.[selectedIndex] || [];
    const allSymbols = [...new Set([selectedIndex, ...equitySymbols])];
    if (allSymbols.length) subscribeSymbols(allSymbols);

    const fetchLatestMarketSnapshot = async () => {
      await loadDashboardIndexMarket({
        indexName: selectedIndex,
      });
    };

    fetchLatestMarketSnapshot();
  }, [selectedIndex, latestDataIndex]);
  console.log("Dashboar ddtaa", dashboardMarketData);
  const currentMarketRows = Object.values(dashboardMarketData || {});

  const latestQuoteTimestamp = currentMarketRows.reduce((latest, item) => {
    const current = new Date(item?.quote_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  const latestIntradayTimestamp = currentMarketRows.reduce((latest, item) => {
    const current = new Date(item?.intraday_updated_at);

    return current > latest ? current : latest;
  }, new Date(0));

  const formatTimestamp = (dateValue) => {
    if (!dateValue) return "";

    const now = new Date(dateValue);

    if (isNaN(now)) return "";

    const day = String(now.getDate()).padStart(2, "0");

    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const month = monthNames[now.getMonth()];

    const year = now.getFullYear();

    const time = now.toLocaleTimeString("en-IN", {
      timeZone: "Asia/Kolkata",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    return `${day}-${month}-${year} | ${time}`;
  };

  const formattedQuoteTime = formatTimestamp(latestQuoteTimestamp);

  const formattedIntradayTime = formatTimestamp(latestIntradayTimestamp);
  const liveIndex = livePrices[selectedIndex];
  const indexQuote = dashboardIndexData?.quote?.data;

  // const indexLastPrice = indexQuote?.last_price;
  const indexLastPrice = liveIndex?.ltp || indexQuote?.last_price;
  const indexOhlc = indexQuote?.ohlc;
  console.log("index ohlc", indexOhlc?.close);
  const prevClose = dashboardIndexData?.hist_data?.hist?.close?.at(-1);

  // const indexLastPrice = indexQuote?.last_price;

  const indexPChange =
    liveIndex?.percentChange ||
    (prevClose && indexLastPrice
      ? Number((((indexLastPrice - prevClose) / prevClose) * 100).toFixed(2))
      : 0);

  const EXPORT_COLUMNS = [
    { header: "Symbol", key: "symbol", width: 15 },
    { header: "Company", key: "company", width: 20 },
    { header: "LTP", key: "ltp", width: 12 },
    { header: "VWAP", key: "vwap", width: 12 },
    { header: "RSI & MACD Trend", key: "prediction", width: 16 },
    { header: "VWAP Trend", key: "vwap_signal", width: 14 },
    { header: "UT Signal", key: "ut_signal", width: 12 },
    { header: "BB Signal", key: "bbawe_signal", width: 12 },
    { header: "Smart Money", key: "smart_signal", width: 14 },
    { header: "Open", key: "open", width: 12 },
    { header: "High", key: "high", width: 12 },
    { header: "Low", key: "low", width: 12 },
    { header: "Prev Close", key: "prev_close", width: 12 },
    { header: "% Change", key: "percent_change", width: 12 },
    { header: "Year High", key: "year_high", width: 14 },
  ];
  const buildExportRows = () => {
    return (
      tableData
        ?.filter((snapshot) => {
          const prediction = snapshot?.intraday?.prediction;
          if (filter === "All") return true;
          return normalizeSignal(prediction) === filter;
        })
        ?.map((snapshot) => {
          const symbol = snapshot?.symbol;
          const quote = snapshot?.quote?.data;
          const intraday = snapshot?.intraday;
          const live = livePrices[symbol];

          const ltp = live?.ltp ?? quote?.last_price ?? "";
          const open = quote?.ohlc?.open ?? "";
          const high = live?.high ?? quote?.ohlc?.high ?? "";
          const low = live?.low ?? quote?.ohlc?.low ?? "";
          const prevClose = snapshot?.prev_close ?? quote?.ohlc?.close ?? "";

          const percentChange =
            prevClose && ltp
              ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
              : 0;

          const prediction = intraday?.prediction || snapshot?.prediction || "";
          const vwap = intraday?.vwap ?? snapshot?.vwap ?? "";
          const vwapSignal =
            intraday?.vwap_signal || snapshot?.vwap_signal || "";
          const utSignal = intraday?.ut_signal || snapshot?.ut_signal || "";
          const bbaweSignal =
            (intraday?.bbawe_signal || snapshot?.bbawe_signal) === "BUY"
              ? "Bullish"
              : "Bearish";
          const smartSignal =
            intraday?.smart_money?.signal ||
            snapshot?.smart_money?.signal ||
            snapshot?.smart_signal ||
            "";

          return {
            symbol,
            company: snapshot?.company || "",
            ltp,
            vwap: vwap ? Number(vwap).toFixed(2) : "",
            prediction,
            vwap_signal: vwapSignal,
            ut_signal: utSignal,
            bbawe_signal: bbaweSignal,
            smart_signal: smartSignal,
            open,
            high,
            low,
            prev_close: prevClose,
            percent_change: percentChange,
            year_high: quote?.["52_week_high"] ?? "",
          };
        }) || []
    );
  };

  const handleDownloadCSV = () =>
    exportCSV({
      rows: buildExportRows(),
      columns: EXPORT_COLUMNS,
      filename: `${selectedIndex}_daily_trend`,
      sheetName: selectedIndex,
    });

  const handleDownloadExcel = () =>
    exportExcel({
      rows: buildExportRows(),
      columns: EXPORT_COLUMNS,
      filename: `${selectedIndex}_daily_trend`,
      sheetName: selectedIndex,
    });
  return (
    <>
      {/* <div className="export-btn-container">
        <div className="trend-export">
          <div className="back-btn">
            <button className="rec-btn" onClick={() => navigate(-1)}>
              Back
            </button>
          </div>
          <div className="select-option dropdown select-index-dropdown">
            <label className="test-page-label" style={{ textAlign: "center" }}>
              Choose Index
            </label>
            <select
              onChange={handleIndexSelect}
              value={selectedIndex}
              // style={{ width: "150px" }}
              className="stocktest-inner-select trend-analysis-head"
            >
              <option value="">Select</option>
              {nseIndicesOptions?.map((item) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>
        </div>
        <h1 className="stocktest-h1 trend-analysis-head">
          {selectedIndex}
          <span style={{ fontSize: "12px", fontWeight: "400" }}>
            {" "}
            {"(Data Refresh lags live data by 5 minutes)"}
          </span>
        </h1>

        <div className="export-files">
          <button className="rec-btn" onClick={handleSendReport}>
            {sending ? "Sending..." : "📧 Email Report"}
          </button>

          <div className="download-dropdown">
            <button
              className="rec-btn"
              onClick={(e) => {
                setOpenDropdown((prev) => !prev);

                e.stopPropagation();
              }}
            >
              Download ⬇
            </button>

            {openDropdown && (
              <div className="download-menu">
                <div
                  className="download-item"
                  onClick={() => {
                    downloadIntradayCSV("intraday");
                    setOpenDropdown(false);
                  }}
                >
                  Download CSV
                </div>

                <div
                  className="download-item"
                  onClick={() => {
                    downloadIntradayExcel("intraday");
                    setOpenDropdown(false);
                  }}
                >
                  Download Excel
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="daily-trend-head daily-trend-time">
        <div className="last-updated-head trend-updated-head">
          <div className="timestamp-head">
            <span>Quote {formattedQuoteTime}</span>
            <span>Intraday {formattedIntradayTime}</span>
          </div>
          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </div>
      </div>
      <div className="stock-table-container">
        <div
          className="stock-responsive-table"
          style={{
            width: "100%",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
          }}
        >
          <table className="stock-table">
            <thead>
              <tr>
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    Company or Ticker
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortCompanyAsc} />
                      <FaChevronDown size={10} onClick={sortCompanyDesc} />
                    </div>
                  </div>
                </th>
                <th>LTP</th>
                <th>VWAP</th>
                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    <span>
                      {" "}
                      RSI & MACD
                      <br />
                      Trend
                    </span>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortPredictionBullish} />
                      <FaChevronDown
                        size={10}
                        onClick={sortPredictionBearish}
                      />
                    </div>
                  </div>
                </th>

                <th>
                  VWAP Trend
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortVwapBullish} />
                    <FaChevronDown size={10} onClick={sortVwapBearish} />
                  </div>
                </th>
                <th>
                  UT Signal
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortUtBullish} />
                    <FaChevronDown size={10} onClick={sortUtBearish} />
                  </div>
                </th>
                <th>
                  BB Signal
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortBbBullish} />
                    <FaChevronDown size={10} onClick={sortBbBearish} />
                  </div>
                </th>
                <th>
                  Smart Money
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      cursor: "pointer",
                    }}
                  >
                    <FaChevronUp size={10} onClick={sortSmartBullish} />
                    <FaChevronDown size={10} onClick={sortSmartBearish} />
                  </div>
                </th>

                <th>Low</th>
                <th>High</th>
                <th>Open</th>
                <th>Prev Close</th>

                <th>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    % Change
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                      }}
                    >
                      <FaChevronUp size={10} onClick={sortPercentHigh} />
                      <FaChevronDown size={10} onClick={sortPercentLow} />
                    </div>
                  </div>
                </th>

                <th>Year High</th>
              </tr>
            </thead>
            <tbody>
              {tableData
                ?.filter((snapshot) => {
                  const prediction = snapshot?.intraday?.prediction;

                  if (filter === "All") return true;

                  return prediction === filter;
                })
                ?.map((snapshot) => {
                  const symbol = snapshot?.symbol;

                  const quote = snapshot?.quote?.data;

                  const intraday = snapshot?.intraday;

                  const ltp = quote?.last_price;

                  const open = quote?.ohlc?.open;

                  const high = quote?.ohlc?.high;

                  const low = quote?.ohlc?.low;

                  const prevClose = quote?.ohlc?.close;

                  const percentChange =
                    prevClose && ltp
                      ? Number(
                          (((ltp - prevClose) / prevClose) * 100).toFixed(2),
                        )
                      : 0;

                  const prediction = snapshot?.prediction;

                  const vwap = snapshot?.vwap;

                  const vwapSignal = snapshot?.vwap_signal;

                  const utSignal = snapshot?.ut_signal;

                  const bbaweSignal =
                    snapshot?.bbawe_signal === "BUY" ? "Bullish" : "Bearish";
                  const security_id = snapshot?.security_id;
                  const smart_signal = snapshot?.smart_money?.signal;

                  return (
                    <tr
                      key={symbol}
                      className="stock-row"
                      onClick={() =>
                        // navigate(`/stockInfo/${symbol}`)}
                        navigate(`/stockdetailpage/${symbol}/${security_id}`)
                      }
                    >
                      <td>{symbol}</td>

                      <td>₹{ltp ?? "-"}</td>

                      <td>
                        {vwap !== undefined
                          ? `₹${Number(vwap).toFixed(2)}`
                          : "-"}
                      </td>

                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            backgroundColor: getBgColor(prediction),
                          }}
                        >
                          {prediction || "Refreshing"}
                        </button>
                      </td>

                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            backgroundColor: getBgColor(vwapSignal),
                          }}
                        >
                          {vwapSignal || "Refreshing"}
                        </button>
                      </td>

                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            backgroundColor: getBgColor(utSignal),
                          }}
                        >
                          {utSignal || "Refreshing"}
                        </button>
                      </td>

                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            backgroundColor: getBgColor(bbaweSignal),
                          }}
                        >
                          {bbaweSignal || "Refreshing"}
                        </button>
                      </td>
                      <td>
                        <button
                          className="rec-btn"
                          style={{
                            backgroundColor: getBgColor(smart_signal),
                          }}
                        >
                          {smart_signal || "Refreshing"}
                        </button>
                      </td>

                      <td>₹{low ?? "-"}</td>

                      <td>₹{high ?? "-"}</td>

                      <td>₹{open ?? "-"}</td>

                      <td>₹{prevClose ?? "-"}</td>

                      <td
                        style={{
                          color: percentChange >= 0 ? "#249966" : "#f87171",
                          fontWeight: "bold",
                        }}
                      >
                        {percentChange}%
                      </td>

                      <td>₹{quote?.["52_week_high"] ?? "-"}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>

        <div className="stock-mobile-card-wrapper">
          {tableData
            ?.filter((snapshot) => {
              const prediction = snapshot?.intraday?.prediction;

              if (filter === "All") return true;

              return prediction === filter;
            })
            ?.map((snapshot) => {
              const symbol = snapshot?.symbol;
              const quote = snapshot?.quote?.data;
              const intraday = snapshot?.intraday;

              const ltp = quote?.last_price;
              const open = quote?.ohlc?.open;
              const high = quote?.ohlc?.high;
              const low = quote?.ohlc?.low;
              const prevClose = quote?.ohlc?.close;

              const percentChange =
                prevClose && ltp
                  ? Number((((ltp - prevClose) / prevClose) * 100).toFixed(2))
                  : 0;

              const prediction = intraday?.prediction;
              const vwap = intraday?.vwap;
              const vwapSignal = intraday?.vwap_signal;
              const utSignal = intraday?.ut_signal;

              const bbaweSignal =
                intraday?.bbawe_signal === "BUY" ? "Bullish" : "Bearish";

              const security_id = snapshot?.security_id;

              const range = high && low ? high - low : 0;

              const closingStrength =
                range && ltp
                  ? Number((((ltp - low) / range) * 100).toFixed(2))
                  : null;

              const reboundStrength =
                range && ltp && open
                  ? Number(
                      (((Math.min(ltp, open) - low) / range) * 100).toFixed(2),
                    )
                  : null;

              const distanceToHigh =
                range && ltp
                  ? Number((((high - ltp) / range) * 100).toFixed(2))
                  : null;

              const smart_signal = snapshot?.smart_money?.signal;
              return (
                <div
                  key={symbol}
                  className="stock-mobile-card"
                  style={{
                    borderLeft: `4px solid ${getBgColor(prediction)}`,
                  }}
                  onClick={() =>
                    navigate(`/stockdetailpage/${symbol}/${security_id}`)
                  }
                >
                  <div className="stock-mobile-card-header">
                    <span className="stock-mobile-company">{symbol}</span>
                  </div>

                  <div className="stock-mobile-card-grid">
                    <div>
                      <p className="label">RSI & MACD</p>
                      <span
                        className="stock-mobile-reco"
                        style={{ backgroundColor: getBgColor(prediction) }}
                      >
                        {prediction || "Refreshing"}
                      </span>
                    </div>
                    <div>
                      <p className="label">VWAP</p>
                      <span
                        className="stock-mobile-reco"
                        style={{ backgroundColor: getBgColor(vwapSignal) }}
                      >
                        {vwapSignal || "Refreshing"}
                      </span>
                    </div>

                    <div>
                      <p className="label">UT</p>
                      <span
                        className="stock-mobile-reco"
                        style={{ backgroundColor: getBgColor(utSignal) }}
                      >
                        {utSignal || "Refreshing"}
                      </span>
                    </div>
                    <div>
                      <p className="label">BB</p>
                      <span
                        className="stock-mobile-reco"
                        style={{ backgroundColor: getBgColor(bbaweSignal) }}
                      >
                        {bbaweSignal || "Refreshing"}
                      </span>
                    </div>
                    <div>
                      <p className="label">Smart Money</p>
                      <span
                        className="stock-mobile-reco"
                        style={{ backgroundColor: getBgColor(smart_signal) }}
                      >
                        {smart_signal || "Refreshing"}
                      </span>
                    </div>

                    <div>
                      <p className="label">LTP</p>
                      <span>₹{ltp ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">VWAP</p>
                      <span>{vwap ? `₹${Number(vwap).toFixed(2)}` : "-"}</span>
                    </div>

                    <div>
                      <p className="label">% Change</p>
                      <span
                        style={{
                          color: percentChange >= 0 ? "#249966" : "#f87171",
                          fontWeight: "700",
                        }}
                      >
                        {percentChange}%
                      </span>
                    </div>

                    <div>
                      <p className="label">Open</p>
                      <span>₹{open ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">High</p>
                      <span>₹{high ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">Low</p>
                      <span>₹{low ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">Prev Close</p>
                      <span>₹{prevClose ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">Year High</p>
                      <span>₹{quote?.["52_week_high"] ?? "-"}</span>
                    </div>

                    <div>
                      <p className="label">Closing Strength</p>
                      <span>
                        {closingStrength !== null ? `${closingStrength}%` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">Rebound Strength</p>
                      <span>
                        {reboundStrength !== null ? `${reboundStrength}%` : "-"}
                      </span>
                    </div>

                    <div>
                      <p className="label">Distance to High</p>
                      <span>
                        {distanceToHigh !== null ? `${distanceToHigh}%` : "-"}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div> */}
      {/* New code */}
      <main className="trendpro-page">
        <section className=" index-row">
          {/* <div className="trendpro-left">
            
            <div className="select-option dropdown testpage-inner-dropdown">
              <label className="test-page-label">Choose Index</label>

              <div className="select-span-index live-span-index">
                <select
                  className="test-select"
                  onChange={handleIndexSelect}
                  value={selectedIndex}
                >
                  <option value="">Select</option>
                  {nseIndicesOptions?.map((item) => (
                    <option key={item} value={item}>
                      {item}
                    </option>
                  ))}
                </select>

                <span
                  className="index-price-data"
                  // style={{
                  //   color:
                  //     dataForIndex?.pChange > 0
                  //       ? "#16a34a"
                  //       : dataForIndex?.pChange < 0
                  //         ? "#dc2626"
                  //         : "#6b7280",

                  // }}
                  style={{
                    color:
                      indexPChange > 0
                        ? "#16a34a"
                        : indexPChange < 0
                          ? "#dc2626"
                          : "#6b7280",
                  }}
                >
                  
                  {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
                  {indexPChange}% )
                </span>
              </div>
            </div>
          </div>
          <IndexTabs /> */}
          <div className="select-option dropdown testpage-inner-dropdown">
            <label className="test-page-label">Choose Index</label>

            <div className="select-span-index">
              <select
                className="test-select"
                onChange={handleIndexSelect}
                value={selectedIndex}
              >
                <option value="">Select</option>
                {nseIndicesOptions?.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>

              <span
                className="index-price-data"
                // style={{
                //   color:
                //     dataForIndex?.pChange > 0
                //       ? "#16a34a"
                //       : dataForIndex?.pChange < 0
                //         ? "#dc2626"
                //         : "#6b7280",

                // }}
                style={{
                  color:
                    indexPChange > 0
                      ? "#16a34a"
                      : indexPChange < 0
                        ? "#dc2626"
                        : "#6b7280",
                }}
              >
                {/* {dataForIndex?.lastPrice} (
                            {dataForIndex?.pChange > 0 ? "+" : ""}
                            {dataForIndex?.pChange}% ) */}
                {indexLastPrice} ({indexPChange > 0 ? "+" : ""}
                {indexPChange}% )
              </span>
            </div>
          </div>
          <IndexTabs />
        </section>

        <section className="trendpro-meta-row">
          <span>Quote {formattedQuoteTime || "—"}</span>
          <span>Intraday {formattedIntradayTime || "—"}</span>

          <FiRefreshCw
            onClick={handleRefresh}
            size={18}
            style={{
              cursor: "pointer",
              transition: "0.2s",
            }}
            onMouseOver={(e) => (e.target.style.color = "#2fd18a")}
            onMouseOut={(e) => (e.target.style.color = "#9ca3af")}
          />
        </section>

        {dashboardLoading && tableData.length === 0 && (
          <section className="trendpro-loading-card">
            Fetching latest market data...
          </section>
        )}

        {dashboardError && (
          <section className="trendpro-error-card">{dashboardError}</section>
        )}

        {tableData.length > 0 && (
          <>
            <section className="trendpro-table-card">
              <div className="trendpro-table-title">
                <div>
                  <h2>{selectedIndex} Live Trend</h2>
                  <p>Data refresh lags live data by 5 minutes</p>
                </div>

                <div className="trendpro-actions">
                  <button onClick={handleSendReport}>
                    {sending ? "Sending..." : "📧 Email Report"}
                  </button>

                  <div className="trendpro-download">
                    <button
                      onClick={(e) => {
                        setOpenDropdown((prev) => !prev);
                        e.stopPropagation();
                      }}
                    >
                      Download ⬇
                    </button>

                    {openDropdown && (
                      // <div className="trendpro-download-menu">
                      //   <div
                      //     onClick={() => {
                      //       downloadIntradayCSV("intraday");
                      //       setOpenDropdown(false);
                      //     }}
                      //   >
                      //     Download CSV
                      //   </div>

                      //   <div
                      //     onClick={() => {
                      //       downloadIntradayExcel("intraday");
                      //       setOpenDropdown(false);
                      //     }}
                      //   >
                      //     Download Excel
                      //   </div>
                      // </div>
                      <div className="trendpro-download-menu">
                        <div
                          onClick={() => {
                            handleDownloadCSV(); // was downloadIntradayCSV("intraday")
                            setOpenDropdown(false);
                          }}
                        >
                          Download CSV
                        </div>

                        <div
                          onClick={() => {
                            handleDownloadExcel(); // was downloadIntradayExcel("intraday")
                            setOpenDropdown(false);
                          }}
                        >
                          Download Excel
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <span>{tableData?.length || 0} Stocks</span>
              </div>

              <div className="stock-table-container"></div>
              <div className="trendpro-table-wrap">
                <table className="trendpro-table stock-table">
                  <thead>
                    <tr>
                      <th>
                        <div className="trendpro-sort-head">
                          Company or Ticker
                          <span>
                            <FaChevronUp size={10} onClick={sortCompanyAsc} />
                            <FaChevronDown
                              size={10}
                              onClick={sortCompanyDesc}
                            />
                          </span>
                        </div>
                      </th>

                      <th>LTP</th>
                      <th>VWAP</th>

                      <th>
                        <div className="trendpro-sort-head">
                          RSI & MACD Trend
                          <span>
                            <FaChevronUp
                              size={10}
                              onClick={sortPredictionBullish}
                            />
                            <FaChevronDown
                              size={10}
                              onClick={sortPredictionBearish}
                            />
                          </span>
                        </div>
                      </th>

                      <th>
                        <div className="trendpro-sort-head">
                          VWAP Trend
                          <span>
                            <FaChevronUp size={10} onClick={sortVwapBullish} />
                            <FaChevronDown
                              size={10}
                              onClick={sortVwapBearish}
                            />
                          </span>
                        </div>
                      </th>

                      <th>
                        <div className="trendpro-sort-head">
                          UT Signal
                          <span>
                            <FaChevronUp size={10} onClick={sortUtBullish} />
                            <FaChevronDown size={10} onClick={sortUtBearish} />
                          </span>
                        </div>
                      </th>

                      <th>
                        <div className="trendpro-sort-head">
                          BB Signal
                          <span>
                            <FaChevronUp size={10} onClick={sortBbBullish} />
                            <FaChevronDown size={10} onClick={sortBbBearish} />
                          </span>
                        </div>
                      </th>

                      <th>
                        <div className="trendpro-sort-head">
                          Smart Money
                          <span>
                            <FaChevronUp size={10} onClick={sortSmartBullish} />
                            <FaChevronDown
                              size={10}
                              onClick={sortSmartBearish}
                            />
                          </span>
                        </div>
                      </th>

                      <th>Low</th>
                      <th>High</th>
                      <th>Open</th>
                      <th>Prev Close</th>

                      <th>
                        <div className="trendpro-sort-head">
                          % Change
                          <span>
                            <FaChevronUp size={10} onClick={sortPercentHigh} />
                            <FaChevronDown size={10} onClick={sortPercentLow} />
                          </span>
                        </div>
                      </th>

                      <th>Year High</th>
                    </tr>
                  </thead>

                  <tbody>
                    {tableData
                      ?.filter((snapshot) => {
                        const prediction = snapshot?.intraday?.prediction;
                        if (filter === "All") return true;
                        return normalizeSignal(prediction) === filter;
                      })
                      ?.map((snapshot) => {
                        const symbol = snapshot?.symbol;
                        const quote = snapshot?.quote?.data;
                        const intraday = snapshot?.intraday;
                        const company = snapshot?.company;
                        // const ltp = quote?.last_price
                        // ;
                        const live = livePrices[symbol];
                        // const ltp = live?.ltp || quote?.last_price;
                        const ltp = live?.ltp || quote?.last_price;
                        const open = quote?.ohlc?.open;
                        const high = live?.high || quote?.ohlc?.high;
                        const low = live?.low || quote?.ohlc?.low;
                        const prevClose =
                          snapshot?.prev_close || quote?.ohlc?.close;

                        const percentChange =
                          prevClose && ltp
                            ? Number(
                                (((ltp - prevClose) / prevClose) * 100).toFixed(
                                  2,
                                ),
                              )
                            : 0;

                        const prediction =
                          intraday?.prediction || snapshot?.prediction;
                        const vwap = intraday?.vwap || snapshot?.vwap;
                        const vwapSignal =
                          intraday?.vwap_signal || snapshot?.vwap_signal;
                        const utSignal =
                          intraday?.ut_signal || snapshot?.ut_signal;
                        const bbaweSignal =
                          (intraday?.bbawe_signal || snapshot?.bbawe_signal) ===
                          "BUY"
                            ? "Bullish"
                            : "Bearish";

                        const smartSignal =
                          intraday?.smart_money?.signal ||
                          snapshot?.smart_money?.signal ||
                          snapshot?.smart_signal;

                        const security_id = snapshot?.security_id;

                        return (
                          <tr
                            key={symbol}
                            onClick={() =>
                              navigate(`/stockdetail/${symbol}/${security_id}`)
                            }
                          >
                            <td>
                              <div className="trendpro-company">
                                <small>{company}</small>
                                <strong>{symbol}</strong>
                                {/* <small>{symbol}</small> */}
                              </div>
                            </td>

                            <td className="trendpro-price">₹{ltp ?? "-"}</td>

                            <td>
                              {vwap ? `₹${Number(vwap).toFixed(2)}` : "-"}
                            </td>

                            <td>
                              <span
                                className={`trendpro-badge ${
                                  normalizeSignal(prediction) === "Bullish"
                                    ? "bull"
                                    : normalizeSignal(prediction) === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {prediction || "Refreshing"}
                              </span>
                            </td>

                            <td>
                              <span
                                className={`trendpro-badge ${
                                  normalizeSignal(vwapSignal) === "Bullish"
                                    ? "bull"
                                    : normalizeSignal(vwapSignal) === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {vwapSignal || "Refreshing"}
                              </span>
                            </td>

                            <td>
                              <span
                                className={`trendpro-badge ${
                                  normalizeSignal(utSignal) === "Bullish"
                                    ? "bull"
                                    : normalizeSignal(utSignal) === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {utSignal || "Refreshing"}
                              </span>
                            </td>

                            <td>
                              <span
                                className={`trendpro-badge ${
                                  normalizeSignal(bbaweSignal) === "Bullish"
                                    ? "bull"
                                    : normalizeSignal(bbaweSignal) === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {bbaweSignal || "Refreshing"}
                              </span>
                            </td>

                            <td>
                              <span
                                className={`trendpro-badge ${
                                  normalizeSignal(smartSignal) === "Bullish"
                                    ? "bull"
                                    : normalizeSignal(smartSignal) === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {smartSignal || "Refreshing"}
                              </span>
                            </td>

                            <td>₹{low ?? "-"}</td>
                            <td>₹{high ?? "-"}</td>
                            <td>₹{open ?? "-"}</td>
                            <td>₹{prevClose ?? "-"}</td>

                            <td>
                              <span
                                className={
                                  percentChange >= 0
                                    ? "trendpro-green"
                                    : "trendpro-red"
                                }
                              >
                                {percentChange}%
                              </span>
                            </td>

                            <td>₹{quote?.["52_week_high"] ?? "-"}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            </section>

            <div className="stock-table-container">
              <section className="trendpro-mobile-list">
                {tableData
                  ?.filter((snapshot) => {
                    const prediction = snapshot?.intraday?.prediction;
                    if (filter === "All") return true;
                    return normalizeSignal(prediction) === filter;
                  })
                  ?.map((snapshot) => {
                    const symbol = snapshot?.symbol;
                    const company = snapshot?.company;
                    const quote = snapshot?.quote?.data;
                    const intraday = snapshot?.intraday;

                    const ltp = quote?.last_price;
                    const open = quote?.ohlc?.open;
                    const high = quote?.ohlc?.high;
                    const low = quote?.ohlc?.low;
                    const prevClose = quote?.ohlc?.close;

                    const percentChange =
                      prevClose && ltp
                        ? Number(
                            (((ltp - prevClose) / prevClose) * 100).toFixed(2),
                          )
                        : 0;

                    // const isPositive = percentChange > 0;
                    const isPositive = percentChange > 0;
                    const isNegative = percentChange < 0;
                    const changeColor =
                      percentChange > 0
                        ? "#249966"
                        : percentChange < 0
                          ? "#f87171"
                          : "#64748b";

                    const prediction =
                      intraday?.prediction || snapshot?.prediction;
                    const vwap = intraday?.vwap || snapshot?.vwap;
                    const vwapSignal =
                      intraday?.vwap_signal || snapshot?.vwap_signal;
                    const utSignal = intraday?.ut_signal || snapshot?.ut_signal;
                    const bbaweSignal =
                      (intraday?.bbawe_signal || snapshot?.bbawe_signal) ===
                      "BUY"
                        ? "Bullish"
                        : "Bearish";

                    const smartSignal =
                      intraday?.smart_money?.signal ||
                      snapshot?.smart_money?.signal ||
                      snapshot?.smart_signal;

                    const security_id = snapshot?.security_id;
                    //  background: isPositive ? "#ecfdf5" : "#fef2f2",

                    //               border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
                    return (
                      <div
                        key={symbol}
                        className="trendpro-mobile-card"
                        onClick={() =>
                          navigate(`/stockdetail/${symbol}/${security_id}`)
                        }
                      >
                        <div className="trendpro-mobile-head">
                          <div className="mobile-head-trendpro">
                            <span className="trendpro-company">{company}</span>
                            <h3>{symbol}</h3>
                          </div>

                          {/* <button
                                    key={item?.index_name}
                                    className="index-chip"
                                    onClick={async () => {
                                      try {
                                        resetDashboardMarketData();
                        
                                        await loadDashboardIndexMarket({
                                          indexName: item?.index_name,
                                        });
                        
                                        navigate(`/indexPage/${item?.index_name}`);
                                      } catch (err) {
                                        console.error("Index navigation failed", err);
                                      }
                                    }}
                                    style={{
                                      background: isPositive ? "#ecfdf5" : "#fef2f2",
                        
                                      border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
                                    }}
                                  >
                                    <span className="index-chip-name">{item?.index_name}</span>
                        
                                    <span
                                      className={isPositive ? "index-chip-green" : "index-chip-red"}
                                    >
                                      ₹{item?.last_price ?? "—"}
                                    </span>
                        
                                    <span
                                      className={isPositive ? "index-chip-green" : "index-chip-red"}
                                    >
                                      {isPositive ? "+" : ""}
                                      {item?.percent_change ?? 0}%
                                      {isPositive ? <IoMdTrendingUp size={18}/> : <IoMdTrendingDown size={18}/>}
                                    </span>
                                  </button> */}

                          <div className="trendpro-mobile-price">
                            <div
                              className="trendpro-mobile-subprice"
                              style={{
                                background: isPositive ? "#ecfdf5" : "#fef2f2",

                                border: `1px solid ${isPositive ? "#86efac" : "#fca5a5"}`,
                              }}
                            >
                              <span
                                className={`trendpro-mobile-ltp ${isPositive ? "index-chip-green" : "index-chip-red"}`}
                              >
                                ₹{ltp ?? "-"}
                              </span>

                              <div
                                className={`trendpro-mobile-change ${
                                  percentChange >= 0 ? "positive" : "negative"
                                }`}
                              >
                                {percentChange >= 0 ? (
                                  <IoMdTrendingUp />
                                ) : (
                                  <IoMdTrendingDown />
                                )}

                                <span
                                  className={
                                    isPositive
                                      ? "index-chip-green"
                                      : "index-chip-red"
                                  }
                                  style={{ color: changeColor }}
                                >
                                  {ltp - prevClose > 0
                                    ? `+${(ltp - prevClose).toFixed(2)}`
                                    : (ltp - prevClose).toFixed(2)}
                                </span>

                                <span
                                  className={
                                    isPositive
                                      ? "index-chip-green"
                                      : "index-chip-red"
                                  }
                                  style={{ color: changeColor }}
                                >
                                  (
                                  {percentChange > 0
                                    ? `+${percentChange}`
                                    : percentChange}
                                  %)
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="trendpro-mobile-grid">
                          <div>
                            <span>VWAP</span>
                            <b>{vwap ? `₹${Number(vwap).toFixed(2)}` : "-"}</b>
                          </div>

                          <div>
                            <span>% Change</span>
                            <b
                              className={
                                percentChange >= 0
                                  ? "trendpro-green"
                                  : "trendpro-red"
                              }
                            >
                              {percentChange}%
                            </b>
                          </div>

                          <div>
                            <span>RSI & MACD</span>

                            <b>
                              <span
                                className={`trendpro-badge ${
                                  normalizeSignal(prediction) === "Bullish"
                                    ? "bull"
                                    : normalizeSignal(prediction) === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {prediction}
                              </span>
                            </b>
                          </div>
                          <div>
                            <span>VWAP Trend</span>

                            <b>
                              <span
                                className={`trendpro-badge ${
                                  vwapSignal === "Bullish"
                                    ? "bull"
                                    : vwapSignal === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {vwapSignal}
                              </span>
                            </b>
                          </div>

                          <div>
                            <span>UT Signal</span>
                            <b>
                              <span
                                className={`trendpro-badge ${
                                  utSignal === "Bullish"
                                    ? "bull"
                                    : utSignal === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {utSignal}
                              </span>
                            </b>
                          </div>

                          <div>
                            <span>BB Signal</span>
                            <b>
                              <span
                                className={`trendpro-badge ${
                                  bbaweSignal === "Bullish"
                                    ? "bull"
                                    : bbaweSignal === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {bbaweSignal}
                              </span>
                            </b>
                          </div>

                          <div>
                            <span>Smart Money</span>
                            <b>
                              <span
                                className={`trendpro-badge ${
                                  smartSignal === "Bullish"
                                    ? "bull"
                                    : smartSignal === "Bearish"
                                      ? "bear"
                                      : "neutral"
                                }`}
                              >
                                {smartSignal}
                              </span>
                            </b>
                          </div>

                          <div>
                            <span>Open</span>
                            <b>₹{open ?? "-"}</b>
                          </div>

                          <div>
                            <span>High</span>
                            <b>₹{high ?? "-"}</b>
                          </div>

                          <div>
                            <span>Low</span>
                            <b>₹{low ?? "-"}</b>
                          </div>

                          <div>
                            <span>Prev Close</span>
                            <b>₹{prevClose ?? "-"}</b>
                          </div>

                          <div>
                            <span>Year High</span>
                            <b>₹{quote?.["52_week_high"] ?? "-"}</b>
                          </div>
                        </div>
                      </div>
                    );
                  })}
              </section>
            </div>
          </>
        )}
      </main>
    </>
  );
};

export default DailyTrend;
